export default "__VITE_ASSET__2fd4977f__"